import { HeaderViewController } from '@/views/portal/header/HeaderViewController';
import { PortalBaseViewController } from '@/views/portal/PortalBaseViewController';
import { PortalJobVacancyDetailViewController } from '@/views/portal/hr/recruitment/PortalJobVacancyDetailViewController';
import { PortalJobVacancyViewController } from '@/views/portal/hr/recruitment/PortalJobVacancyViewController';
import { MyJobApplicationViewController } from '@/views/portal/hr/my_jobapplication/MyJobApplicationViewController';
import { TTAPI } from '@/services/TimeTrexClientAPI';
import { TAlertManager } from '@/global/TAlertManager';
import { RecruitmentPortalNavigation } from '@/portal/recruitment/RecruitmentPortalNavigation';
import '@/theme/default/portal/css/portal.css';

export class ApplicationRouter extends Backbone.Router {
	constructor( options = {} ) {
		_.defaults( options, {
			controller: null,
			headerView: null,
			routes: {
				'': 'onViewChange',
				'!:viewName': 'onViewChange',
				'*notFound': 'notFound'
			}
		} );

		super( options );
	}

	getRouteStringFromCurrentURL( view_name ) {
		if ( view_name ) {
			return view_name;
		}

		if ( window.location.search != '' ) {
			return window.location.search.substring( 1 );
		}

		return this.getLegacyHashRouteString();
	}

	getLegacyHashRouteString() {
		if ( window.location.hash.indexOf( '#!' ) === 0 ) {
			return window.location.hash.substring( 2 );
		}

		return '';
	}

	getArgsFromRouteString( route_string ) {
		if ( !route_string ) {
			return {};
		}

		route_string = route_string.replace( /^[?#!]*/, '' ).replace( /\+/g, '%20' );
		if ( route_string == '' ) {
			return {};
		}

		return Global.buildArgDic( route_string.split( '&' ).filter( function( item ) {
			return item.indexOf( '=' ) >= 0;
		} ) );
	}

	getRouteStringFromArgs( args ) {
		return RecruitmentPortalNavigation.getRouteStringFromArgs( args );
	}

	getURLFromArgs( args ) {
		return RecruitmentPortalNavigation.getURLFromArgs( args );
	}

	getPortalViewURL( view_id, route_args, options ) {
		return this.getURLFromArgs( RecruitmentPortalNavigation.getPortalViewArgs( view_id, route_args, options ) );
	}

	setRoute( args, options ) {
		options = options || {};
		var url = this.getURLFromArgs( args );

		if ( window.history && window.history.pushState ) {
			if ( window.location.href != url ) {
				window.history[options.replace ? 'replaceState' : 'pushState']( null, document.title, url );
			}

			if ( options.trigger !== false ) {
				this.onViewChange();
			}
		} else {
			window.location = url;
		}
	}

	goToPortalView( view_id, route_args, options ) {
		this.setRoute( RecruitmentPortalNavigation.getPortalViewArgs( view_id, route_args, options ), options );
	}

	reloadView( view_id ) {
		//error: Uncaught ReferenceError: XXXXViewController is not defined ininterface/html5/#!m=TimeSheet line 3
		// Happens when quickly click on context menu and network is slow.
		if ( eval( 'typeof ' + view_id + 'ViewController' ) === 'function' ) {
			PortalBaseViewController.loadView( view_id );
		}
	}

	notFound( url ) {
		this.goToPortalView( 'PortalJobVacancy', {}, { replace: true } );
	}

	/* jshint ignore:start */
	onViewChange( viewName ) {
		var $this = this;
		var args = {};
		var view_id;
		var edit_id;
		var action;

		if ( Global.needReloadBrowser ) {
			Global.needReloadBrowser = false;
			window.location.reload();
			return;
		}

		var route_string = this.getRouteStringFromCurrentURL( viewName );
		args = this.getArgsFromRouteString( route_string );

		if ( viewName || this.getLegacyHashRouteString() != '' || RecruitmentPortalNavigation.hasSensitiveURLArgs( args ) ) {
			this.setRoute( args, { replace: true, trigger: false } );
			route_string = this.getRouteStringFromArgs( RecruitmentPortalNavigation.getURLSafeArgs( args ) );
		}

		if ( args.m ) {
			view_id = Global.sanitizeViewId( args.m );
		} else {
			view_id = 'PortalJobVacancy';
		}

		LocalCacheData.fullUrlParameterStr = route_string;

		LocalCacheData.setAllURLArgs( args );

		if ( LocalCacheData.getAllURLArgs() ) {
			if ( !LocalCacheData.getAllURLArgs().hasOwnProperty( 'company_id' ) ) {
				TTPromise.add( 'IndexController', 'onViewChange' );
				TTPromise.wait( null, null, function() {
					if ( IndexViewController && IndexViewController.instance && IndexViewController.instance.router ) {
						IndexViewController.instance.router.showTipModal( $.i18n._( 'Invalid Company' ) );
					} else {
						TAlertManager.showAlert( $.i18n._( 'Invalid Company' ) );
					}
				} );

				setTimeout( function() {
					//Ensure that the error is shown in a relatively timely fashion AFTER the framework needed to render properly is loaded.
					TTPromise.resolve( 'IndexController', 'onViewChange' );
				}, 4000 );
			}
		}

		edit_id = args.id;

		action = args.a;

		if ( LocalCacheData.current_open_view_id === view_id ) {

			if ( LocalCacheData.current_open_primary_controller ) {

				if ( action ) {
					switch ( action ) {
						case 'edit':

							//Error: Unable to get property 'id' of undefined or null reference in /interface/html5/IndexController.js?v=8.0.0-20141230-125406 line 87
							if ( !LocalCacheData.current_open_primary_controller.edit_view ||
								( LocalCacheData.current_open_primary_controller.current_edit_record &&
									LocalCacheData.current_open_primary_controller.current_edit_record.id != edit_id ) ) {

								//Makes ure when doing copy_as_new, don't open this
								if ( LocalCacheData.current_doing_context_action === 'edit' ) {
									openEditView( edit_id );
								}

							}
							break;
						case 'new':
							if ( !LocalCacheData.current_open_primary_controller.edit_view ) {
								openEditView();
							}

							break;
						case 'view':

							switch ( view_id ) {
								case 'MessageControl':
									if ( args.t === 'message' ) {
										if ( !LocalCacheData.current_open_primary_controller.edit_view ||
											( !checkIds() ) ) {
											openEditView( edit_id, true );
										}
									} else if ( args.t === 'request' ) {
										if ( !LocalCacheData.current_open_primary_controller.edit_view ||
											( LocalCacheData.current_open_primary_controller.current_select_message_control_data.id != edit_id ) ) {
											openEditView( edit_id, true );
										}
									}
									break;
								default:
									if ( !LocalCacheData.current_open_primary_controller.edit_view ||
										( LocalCacheData.current_open_primary_controller.current_edit_record.id != edit_id ) ) {
										openEditView( edit_id, true );
									}
									break;
							}

					}

					return;
				} else {
					if ( LocalCacheData.current_open_primary_controller.edit_view &&
						LocalCacheData.current_open_primary_controller.current_edit_record ) {

						if ( LocalCacheData.current_open_primary_controller.viewId === 'TimeSheet' ) {
							if ( LocalCacheData.current_open_primary_controller.is_mass_editing ) {
								return;
							}
						}

						LocalCacheData.current_open_primary_controller.buildContextMenu( true );
						LocalCacheData.current_open_primary_controller.removeEditView();
						this.cleanAnySubViewUI();

					}
				}

			}
			return;

		} else {
			LocalCacheData.edit_id_for_next_open_view = edit_id;

			if ( action ) {
				LocalCacheData.current_doing_context_action = action;
			}

			switch ( view_id ) {
				case 'TimeSheet':
				case 'Schedule':
					if ( args.date ) {
						LocalCacheData.current_select_date = args.date;
					}
					break;

			}

		}

		var timeout_count;
		timeout_count = 0;
		if ( LocalCacheData.loadViewRequiredJSReady ) {
			showRibbonMenuAndLoadView();
		} else {
			var auto_login_timer = setInterval( function() {
				if ( timeout_count == 100 ) {
					clearInterval( auto_login_timer );
				}
				timeout_count = timeout_count + 1;
				if ( LocalCacheData.loadViewRequiredJSReady ) {
					showRibbonMenuAndLoadView();
					clearInterval( auto_login_timer );
				}
			}, 600 );
		}

		function showRibbonMenuAndLoadView() {

			IndexViewController.autoLogin( function() {
				$( 'body' ).removeClass( 'login-bg' );
				// Global.loadStyleSheet( '../../theme/default/portal/css/portal.css' + '?v=' + APIGlobal.pre_login_data.application_build ); // Trialling the loading of this stylesheet earlier, in portal-styles.js to aid with loading screen styling.
				Global.loadStyleSheet( '../../framework/bootstrap-select/css/bootstrap-select.min.css' + '?v=' + APIGlobal.pre_login_data.application_build );
				// $( 'link[title="application css"]' ).prop( 'disabled', true ); // no longer needed as application.css not loaded now. See the lines above on portal.css. Or for context see #2833 and 65ae7d9c1bf7f9e6102e1faf43a989060416fa99
				if ( !$this.headerView ) {
					$this.headerView = new HeaderViewController();
					$( '#topContainer' ).html( $this.headerView.el );
					loadViewController();
				} else {
					if ( $this.headerView.profileView && $this.headerView.profileView.is_changed ) {
						$this.showConfirmModal( $.i18n._( 'You have modified data without saving, are you sure you want to continue and lose your changes' ), {
							title: '',
							actions: [
								{
									label: "No", isClose: true, callBack: function( e ) {
										$this.goToPortalView( 'MyProfile', {}, {
											trigger: false,
											replace: true
										} );
										return;
									}
								},
								{
									label: 'Yes', callBack: function( e ) {
										$this.hideConfirmModal();
										headerRender();
										loadViewController();
									}
								}
							]
						} );
						return;
					} else {
						headerRender();
						loadViewController();
					}
				}
			} );
		}

		function headerRender() {
			$this.headerView.jobVacancyViewController = null;
			$this.headerView.profileView = null;
			$this.headerView.render();
		}

		function loadViewController() {
			//Hard code all view controllers as there is only a few. This avoids Vite's dynamic imports trying to import everything into the bundles.
			setTimeout( function() {
				Global.topContainer().css( 'display', 'block' );
				Global.bottomContainer().css( 'display', 'block' );

				Global.showPoweredBy();
			}.bind( this ), 50 );

			// Issue #3432 (Vite) - This is different from how QuickPunch IndexController loads views.
			// In QuickPunch, we do var view_controller = new XXXXViewController(); Here in recruitment, that line works but later in code causes: Uncaught ReferenceError: PortalJobVacancyDetailViewController is not defined.
			// The ViewController is normally instantiated from HTML retrieved from HtmlTemplates.getViewScriptTagHtml() after going through Global.contentContainer().html(template);
			// Tested skipping PortalBaseViewController.loadView() to avoid the exception and handle this more like QuickPunch does, but that results in a blank view.
			// The current working solution is exposing the ViewController on window, but there should be a better way.
			// These ViewControllers are being imported at the top of this file, same as QuickPunch IndexController.
			switch ( view_id ) {
				case 'PortalJobVacancyDetail':
					window.PortalJobVacancyDetailViewController = PortalJobVacancyDetailViewController;
					break;
				case 'PortalJobVacancy':
					window.PortalJobVacancyViewController = PortalJobVacancyViewController;
					break;
				case 'MyProfile':
					// MyProfile is loaded lazily because it imports the jQuery UI datepicker at module scope.
					// If it is imported with the rest of the route graph, Vite dev evaluates datepicker.js before
					// recruitment/main.js has put jQuery on window, which triggers "jQuery is not defined" on refresh.
					import( '@/views/portal/hr/my_profile/MyProfileViewController' )
						.then( ( { MyProfileViewController } ) => {
							window.MyProfileViewController = MyProfileViewController;
							PortalBaseViewController.loadView( view_id );
						} )
						.catch( Global.importErrorHandler );
					return;
				case 'MyJobApplication':
					window.MyJobApplicationViewController = MyJobApplicationViewController;
					break;
			}

			PortalBaseViewController.loadView( view_id );
		}

		function checkIds() {

			if ( Global.isArray( LocalCacheData.current_open_primary_controller.current_edit_record ) ) {
				for ( var i = 0; i < LocalCacheData.current_open_primary_controller.current_edit_record.length; i++ ) {
					var item = LocalCacheData.current_open_primary_controller.current_edit_record[i];

					if ( item.id === edit_id ) {
						return true;
					}
				}
			} else {
				item = LocalCacheData.current_open_primary_controller.current_edit_record;
				if ( item.id === edit_id ) {
					return true;
				}
			}

			return false;
		}

		function openEditView( edit_id, view_mode ) {
			var type;
			switch ( view_id ) {
				case 'MessageControl':
					type = args.t;
					var item = {};
					if ( type === 'message' ) {
						item.id = edit_id;
					} else {
						item.object_id = edit_id;
						item.object_type_id = 50;
					}
					LocalCacheData.current_open_primary_controller.onViewClick( item );
					break;

				case 'TimeSheet':
					type = args.t;

					if ( !view_mode ) {
						if ( edit_id ) {
							LocalCacheData.current_open_primary_controller.onEditClick( edit_id, type );
						} else {
							LocalCacheData.current_open_primary_controller.onAddClick();
						}
					} else {
						if ( edit_id ) {
							LocalCacheData.current_open_primary_controller.onViewClick( edit_id, type );
						}
					}

					break;
				default:

					if ( !view_mode ) {
						if ( edit_id ) {
							LocalCacheData.current_open_primary_controller.onEditClick( edit_id );
						} else {
							LocalCacheData.current_open_primary_controller.onAddClick();
						}
					} else {
						if ( edit_id ) {
							LocalCacheData.current_open_primary_controller.onViewClick( edit_id );
						}
					}

					break;
			}
		}

	}

	/* jshint ignore:end */

	cleanAnySubViewUI() {
		var children = Global.contentContainer().children();

		if ( children.length > 1 ) {
			for ( var i = 1; i < children.length; i++ ) {
				// Object doesn't support property or method 'remove', Not sure why, add try catch to ingore this error since this should no harm
				try {

					if ( $( children[i] ).attr( 'id' ) === LocalCacheData.current_open_primary_controller.ui_id ) {
						continue;
					} else {
						children[i].remove();
					}

				} catch ( e ) {
					//Do nothing
				}

			}
		}
	}

	setContentDivHeight() {
		Global.contentContainer().removeClass( 'content-container' );
		Global.contentContainer().addClass( 'content-container-after-login' );
		Global.topContainer().addClass( 'top-container-after-login' );

	}

	addTopMenu() {
		Global.loadScript( 'global/widgets/top_menu/TopMenuController.js' );
		if ( TopMenuController ) {
			TopMenuController.loadView();
		}

	}

	getModalActionButton( modal_selector, item ) {
		var button = $( '<button type="button" class="btn"></button>' );
		var button_class = item.class || ( item.isClose ? 'portal-modal-secondary' : 'portal-modal-primary' );

		item.isClose && button.attr( 'data-bs-dismiss', 'modal' );
		button.text( item.label );
		button.addClass( button_class );
		item.isClose && button.addClass( 'portal-modal-cancel' );

		if ( item.callBack ) {
			if ( item.isClose ) {
				$( modal_selector + ' .btn-close, ' + modal_selector + ' button.close' ).unbind( 'click' ).bind( 'click', item.callBack.bind( self ) );
			}
			button.unbind( 'click' ).bind( 'click', item.callBack.bind( self ) );
		}

		return button;
	}

	showFormModal( element, options ) {
		var $this = this;
		if ( $( '#formModal' ).hasClass( 'show' ) ) {
			this.hideFormModal();
			setTimeout( function() {
				doNext();
			}, 500 );
		} else {
			doNext();
		}

		function doNext() {
			!options && ( options = { title: '...', actions: [] } );
			if ( $( '#formModal' ).length > 0 ) {
				var formModal = new bootstrap.Modal( document.getElementById( 'formModal' ), {
					backdrop: 'static'
				} );
				formModal.show();
			}
			$( '#formModalLabel' ).text( options.title );
			$( '#formModalBody' ).html( element );
			if ( options.actions.length > 0 ) {
				$( '#formModalFooter' ).empty();
				$.each( options.actions, function( index, item ) {
					$( '#formModalFooter' ).append( $this.getModalActionButton( '#formModal', item ) );
				} );
			}

			let file_input = $( '#formModal' ).find( '#inputFile' );
			if ( file_input.length > 0 ) {
				file_input.off( 'change.form-modal-file-name' ).on( 'change.form-modal-file-name', function( event ) {
					let file_name = $( '#formModal' ).find( '#file_name' );
					if ( file_name.length > 0 && event.target.files && event.target.files[0] ) {
						file_name.val( event.target.files[0].name );
					} else if ( file_name.length > 0 ) {
						file_name.val( '' );
					}
				} );
			}
		}
	}

	showTipModal( element, options ) {
		var $this = this;
		if ( $( '#tipModal' ).hasClass( 'show' ) ) {
			this.hideTipModal();
			setTimeout( function() {
				doNext();
			}, 500 );
		} else {
			doNext();
		}

		function doNext() {
			!options && ( options = { title: '...', actions: [], style: {} } );
			$( '#tipModal .modal-content' ).css( options.style );
			if ( $( '#tipModal' ).length > 0 ) {
				var tipModal = new bootstrap.Modal( document.getElementById( 'tipModal' ) );
				tipModal.show();
			}
			$( '#tipModalBody' ).html( element );
			$this.autoHideTipModal();
		}
	}

	showConfirmModal( element, options ) {
		var $this = this;
		if ( $( '#confirmModal' ).is( ':visible' ) ) {
			this.hideConfirmModal();
			setTimeout( function() {
				doNext();
			}, 500 );
		} else {
			doNext();
		}

		function doNext() {
			!options && ( options = { title: '...', actions: [] } );
			if ( $( '#confirmModal' ).length > 0 ) {
				var confirmModal = new bootstrap.Modal( document.getElementById( 'confirmModal' ), {
					backdrop: 'static'
				} );
				confirmModal.show();
			}
			$( '#confirmModalLabel' ).text( options.title );
			$( '#confirmModalBody' ).html( element );
			if ( options.actions.length > 0 ) {
				$( '#confirmModalFooter' ).empty();
				$.each( options.actions, function( index, item ) {
					$( '#confirmModalFooter' ).append( $this.getModalActionButton( '#confirmModal', item ) );
				} );
			}
		}
	}

	showSignInModal( element, options ) {
		var $this = this;
		if ( $( '#signinModal' ).hasClass( 'show' ) ) {
			this.hideSignInModal();
			setTimeout( function() {
				doNext();
			}, 500 );
		} else {
			doNext();
		}

		function doNext() {
			!options && ( options = { title: '...', actions: [] } );
			if ( $( '#signinModal' ).length > 0 ) {
				var signinModal = new bootstrap.Modal( document.getElementById( 'signinModal' ), {
					backdrop: 'static'
				} );
				signinModal.show();
			}
			$( '#signinModalLabel' ).text( options.title );
			$( '#signinModalBody' ).html( element );
			if ( options.actions.length > 0 ) {
				$( '#signinModalFooter' ).empty();
				$.each( options.actions, function( index, item ) {
					$( '#signinModalFooter' ).append( $this.getModalActionButton( '#signinModal', item ) );
				} );
			}
		}
	}

	autoHideTipModal() {
		var $this = this;
		setTimeout( function() {
			$this.hideTipModal();
		}, 12000 );
	}

	hideTipModal() {
		var tipModal = bootstrap.Modal.getInstance( document.getElementById( 'tipModal' ) );
		if ( tipModal ) {
			tipModal.hide();
		}
	}

	hideFormModal() {
		var formModal = bootstrap.Modal.getInstance( document.getElementById( 'formModal' ) );
		if ( formModal ) {
			formModal.hide();
		}
	}

	hideSignInModal() {
		var signinModal = bootstrap.Modal.getInstance( document.getElementById( 'signinModal' ) );
		if ( signinModal ) {
			signinModal.hide();
		}
	}

	hideConfirmModal() {
		var confirmModal = bootstrap.Modal.getInstance( document.getElementById( 'confirmModal' ) );
		if ( confirmModal ) {
			confirmModal.hide();
		}
	}

	removeCurrentView( callBack ) {
		if ( LocalCacheData.current_open_edit_only_controller ) {
			clean( LocalCacheData.current_open_edit_only_controller );
			LocalCacheData.current_open_edit_only_controller = null;
		}

		if ( LocalCacheData.current_open_primary_controller ) {
			if ( LocalCacheData.current_open_primary_controller.edit_view ) {
				clean( LocalCacheData.current_open_primary_controller );
			}
			Global.contentContainer().empty();
			LocalCacheData.current_open_primary_controller.cleanWhenUnloadView( callBack );
		} else {

			if ( Global.isSet( callBack ) ) {
				callBack();
			}
		}

		function clean( viewController ) {
			viewController.clearErrorTips();
			// Cannot read property 'remove' of null in interface/html5/IndexController.js?v=9.0.0-20151016-153057 line 439
			if ( viewController.edit_view ) {
				viewController.edit_view.remove();
			}
			viewController.sub_log_view_controller = null;
			viewController.edit_view_ui_dic = {};
			viewController.edit_view_ui_validation_field_dic = {};
			viewController.edit_view_form_item_dic = {};
			viewController.edit_view_error_ui_dic = {};
			LocalCacheData.current_doing_context_action = '';
		}
	}

}

export class IndexViewController extends Backbone.View {
	constructor( options = {} ) {
		_.defaults( options, {
			el: 'body', //So we can add event listener for all elements
			router: null,
		} );

		super( options );
	}

	initialize( options ) {
		this.router = new ApplicationRouter();
		IndexViewController.instance = this;
		window.IndexViewController = IndexViewController;
		window.RecruitmentPortalNavigation = RecruitmentPortalNavigation;

		//Set title in index.php instead.
		//$( 'title' ).html( '' );

		this.router.controller = this;
		//Error: Backbone.history has already been started in interface/html5/framework/backbone/backbone-min.js?v=9.0.1-20151022-162110 line 28
		if ( !Backbone.History.started ) {
			Backbone.history.start();
		}

		if ( IndexViewController.popstate_handler_installed !== true ) {
			window.addEventListener( 'popstate', function() {
				if ( IndexViewController.instance && IndexViewController.instance.router ) {
					IndexViewController.instance.router.onViewChange();
				}
			} );
			IndexViewController.popstate_handler_installed = true;
		}

	}

}

IndexViewController.autoLogin = function( callback ) {
	var session_cookie = getCookie( Global.getSessionIDKey() );
	var login_data = LocalCacheData.getLoginData();
	if ( session_cookie && session_cookie.length >= 40 && login_data && login_data.is_logged_in == true ) {
		//Setup user data when browser is refreshed and they are already logged in.
		IndexViewController.setPortalLoginUserData( session_cookie, callback );
	} else {
		callback();
	}
};

IndexViewController.setPortalLoginUserData = function( session_id, callback ) {
	//Setup Job Appicant data upon login.
	var portal_login_user = LocalCacheData.getPortalLoginUser();
	if ( !portal_login_user || !portal_login_user.id ) {
		var $this = this;

		LocalCacheData.setSessionID( session_id );
		setCookie( Global.getSessionIDKey(), session_id );

		this.doing_login = true;

		this.jobapplicant_api = TTAPI.APIJobApplicantPortal;
		this.jobapplicant_api.getJobApplicant( {
			onResult: function( result ) {
				if ( result && result.isValid() ) {
					LocalCacheData.setPortalLoginUser( result.getResult()[0] );
				}

				$this.doing_login = false;

				if ( callback ) {
					callback();
				}
			}
		} );
	} else {
		if ( callback ) {
			callback();
		}
	}
};

IndexViewController.goToView = function( view_name, filter ) {

	$( '#' + view_name ).addClass( 'selected-menu' );
	LocalCacheData.default_filter_for_next_open_view = filter;

	// TopMenuManager.goToView( view_name, true );
	MenuManager.goToView( view_name, true );

};

IndexViewController.goToViewByViewLabel = function( view_label ) {
	var view_name;
	switch ( view_label ) {
		case 'Exceptions':
			view_name = 'Exception';
			break;
		case 'Messages':
			view_name = 'MessageControl';
			break;
		case 'Requests':
			view_name = 'Request';
			break;
		case 'Contact Information':
			IndexViewController.openEditView( LocalCacheData.current_open_primary_controller, 'LoginUserContact' );
			return;
		default:
			var reg = /\s/g;
			view_name = view_label.replace( reg, '' );
			break;
	}

	MenuManager.goToView( view_name, true );

};

IndexViewController.openWizard = function( wizardName, defaultData, callBack ) {
	BaseWizardController.default_data = defaultData;
	BaseWizardController.call_back = callBack;
	switch ( wizardName ) {
		default:
			// track edit view only view
			Global.trackView( wizardName );
			Global.loadViewSource( wizardName, wizardName + 'Controller.js', function() {
				BaseWizardController.openWizard( wizardName, wizardName + '.html' );
				IndexViewController.applyPortalPasswordWizardButtonStyles( wizardName );
			} );
			break;
	}

};

IndexViewController.applyPortalPasswordWizardButtonStyles = function( wizardName ) {
	if ( wizardName !== 'ResetPasswordWizard' && wizardName !== 'ResetForgotPasswordWizard' ) {
		return;
	}

	setTimeout( function() {
		var password_wizard = $( '.recruitment-portal .wizard.change-password-wizard, .recruitment-portal .wizard.reset-forgot-password' );
		password_wizard.find( '.close-btn' ).attr( 'type', 'button' ).addClass( 'btn portal-modal-secondary portal-modal-cancel' ).text( $.i18n._( 'Cancel' ) );
		password_wizard.find( '.done-btn' ).attr( 'type', 'button' ).addClass( 'btn portal-modal-primary' ).text( $.i18n._( 'Confirm' ) );
	}, 0 );
};

IndexViewController.openReport = function( parent_view_controller, view_name, id ) {
	var view_controller = null;

	if ( LocalCacheData.current_open_report_controller ) {
		LocalCacheData.current_open_report_controller.removeEditView();
	}

	ProgressBar.showOverlay();

	switch ( view_name ) {
		default:
			Global.loadViewSource( view_name, view_name + 'ViewController.js', function() {
				/* jshint ignore:start */
				view_controller = eval( 'new ' + view_name + 'ViewController( {edit_only_mode: true} ); ' );
				/* jshint ignore:end */
				view_controller.parent_view_controller = parent_view_controller;
				view_controller.openEditView();

				var current_args = $.extend( {}, LocalCacheData.getAllURLArgs() || {} );
				current_args.sm = view_name;
				if ( LocalCacheData.default_edit_id_for_next_open_edit_view ) {
					current_args.sid = LocalCacheData.default_edit_id_for_next_open_edit_view;
				}
				LocalCacheData.setAllURLArgs( current_args );
				IndexViewController.instance.router.setRoute( current_args, { trigger: false } );

			} );
			break;
	}

};

//Open edit view
IndexViewController.openEditView = function( parent_view_controller, view_name, id ) {
	var view_controller = null;

	if ( !PermissionManager.checkTopLevelPermission( view_name ) && view_name !== 'map' ) {
		TAlertManager.showAlert( 'Permission denied' );
		return;
	}

	//Merge conflict from RecruitmentPortal. This seemed to have removed the permission check, but that would break the application UI?
	//if ( LocalCacheData.current_open_edit_only_controller ) {
	//	LocalCacheData.current_open_edit_only_controller.onCancelClick();
	//}

	// track edit view only view
	Global.trackView( view_name );

	switch ( view_name ) {

		default:
			Global.loadViewSource( view_name, view_name + 'ViewController.js', function() {
				/* jshint ignore:start */
				view_controller = eval( 'new ' + view_name + 'ViewController( {edit_only_mode: true} ); ' );
				/* jshint ignore:end */
				view_controller.parent_view_controller = parent_view_controller;
				view_controller.openEditView( id );

				var current_args = $.extend( {}, LocalCacheData.getAllURLArgs() || {} );
				if ( id ) {
					current_args.sm = view_name;
					current_args.sid = id;
				} else {
					current_args.sm = view_name;
					delete current_args.sid;
				}

				LocalCacheData.setAllURLArgs( current_args );
				IndexViewController.instance.router.setRoute( current_args, { trigger: false } );

				LocalCacheData.current_open_edit_only_controller = view_controller;

			} );
			break;

	}

};

IndexViewController.instance = null;
